import { Row, Col, ListGroup } from "react-bootstrap";
import Review from '../../components/products/Review';

export default function ReviewsList(props) {
  // list of reviews
  // props:
  //      reviews: a list of review javascript objects
  //      editable: add edit button (for user's own reviews) + link to proudct
  //      deletable: add delete button (for user's own reviews + admin) + link to product
  return (
    <Row>
      <Col>
        <ListGroup variant="flush">
          {props?.reviews.map((review, idx) => {
            return (
              <Review key={idx} 
                review={review}
                editable={props?.editable}
                deletable={props?.deletable}
                handleEdit={props.handleEdit}
                handleDelete={props.handleDelete}
              /> 
            );
          })}
        </ListGroup>
      </Col>
    </Row>
  );
}
